import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  SUBSCRIPTION_STATUS,
  SWAL_SETTINGS,
  THEME_COLORS,
  showFilterlistByUser,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,

  formateDateWithMonth,

  handleServerValidations,

  TrimText,
  usePermission,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { List, cancelSubscription } from "../../services/userSubscription.service"
import { Dropdown, Placeholder, Tooltip, Whisper } from "rsuite";
const UserSubscriptionTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can } = usePermission();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("label_user_subscriptions"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false)
  const [dateRange, setDateRange] = useState({});





  /********** MULTI SELECT <<<<<<********* */

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        if (dateRange.start) formData.append("start_date", dateRange.start);
        if (dateRange.end) formData.append("end_date", dateRange.end);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
    statusUpdated,
    dateRange
  ]);

  const viewfunction = (row) => {
    navigate(
      `/admin/subscription/user-subscription-plan/view/${row._id}`
    );
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };


  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setDateRange({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };

  const CancelSubscription = (row) => {

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_cancel"),
      cancelButtonText: "No"
    }).then((result) => {
      if (result.isConfirmed) {


        cancelSubscription({ _id: row._id }).then(response => {
          setStatusUpdate(!statsupdate)
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }








  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("label_user_subscriptions")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      setDateRange(e && e.start ? e : {});
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={[{ name: "All", status__id: "" }, ...Object.values(SUBSCRIPTION_STATUS).map((value) => ({ name: capitalizeFirstLetter(value), status__id: value }))]}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn"
                >
                  {t("btn_reset_filter")}
                </button>
              </div>
            </div>
            {
              loader ?
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                :
                <>
                  <div className="table-responsive min-h-400">
                    <table className="table table-bordered card-table border-top text-nowrap w-100">
                      <thead>
                        <tr>
                          <th className="position-relative select_head">
                            <span>{t("list_heading_sno")}</span>
                          </th>
                          <th>
                            <div className="sorting_column">
                              <span>{t("label_name")}</span>
                              <Sorting
                                sort={sorting}
                                handleSort={handleSort}
                                column="name"
                              />
                            </div>
                          </th>

                          <th>{t("label_email")}</th>
                          <th className="status_head">{t("label_price")}</th>
                          <th className="status_head">Discounted Amount</th>
                          <th className="status_head">{t("label_type")}</th>
                          <th className="status_head">{t("list_heading_status")}</th>
                          <th className="created_head">
                            <div className="sorting_column">
                              <span>{t("list_heading_created_date")}</span>
                            </div>
                          </th>


                          <th className="created_head">
                            <div className="sorting_column">
                              <span>{t("list_heading_expire_date")}</span>
                            </div>
                          </th>
                          {(can("/admin/subscription/user-subscription-plan/view") || can("/admin/subscription/user-subscription-plan/cancel")) && (
                            <th className="action_head">{t("list_heading_action")}</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <>
                          {list.length ? (
                            list.map((row, i) => {
                              return (
                                <tr
                                  key={i}
                                >
                                  <td>
                                    {row ? ((page - 1) * itemperpage) + i + 1 : null}
                                  </td>



                                  <td>{row?.userDetails?.name ? <div className="d-flex">{row?.userDetails?.name ? TrimText(capitalizeFirstLetter(row?.userDetails?.name), 20) : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                                  <td>{row?.userDetails?.email ? row.userDetails?.email : "N/A"}</td>


                                  <td>{row?.subscriptionPrice ? `$${row.subscriptionPrice}` : "N/A"}</td>
                                  <td>{row?.discount ? `$${row.discount / 100}` : "N/A"}</td>

                                  <td>{row?.subscriptionPlanDetail?.name ? row?.subscriptionPlanDetail?.name : "N/A"}</td>

                                  <td>
                                    {(() => {
                                      if (row.status === SUBSCRIPTION_STATUS.PENDING) {
                                        return <span className="badge badge-pill badge-primary-light text-capitalize">{t(row.status)}</span>
                                      } else if (row.status === SUBSCRIPTION_STATUS.CANCELLED) {
                                        return <span className="badge badge-pill badge-danger-light text-capitalize">{t(row.status)}</span>
                                      } else if (row.status === SUBSCRIPTION_STATUS.ACTIVE) {
                                        return <span className="badge badge-pill badge-success-light text-capitalize">{t(row.status)}</span>
                                      } else {
                                        return <span className="badge badge-pill badge-info-light text-capitalize">Unknown</span>
                                      }
                                    })()}
                                  </td>


                                  <td>
                                    {row?.startDate
                                      ? formateDateWithMonth(row.startDate)
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {row?.endDate
                                      ? formateDateWithMonth(row.endDate)
                                      : "N/A"}
                                  </td>
                                  {(can("/admin/subscription/user-subscription-plan/view") || can("/admin/subscription/user-subscription-plan/cancel")) && (
                                    <td>

                                      {/* <div className="d-flex">
                                        <button className="btn ripple btn-main-primary signbtn" onClick={() => { viewfunction(row); }} > {t("btn_view")} </button>
                                        <button className="btn ripple btn-secondary mlAction" onClick={() => {CancelSubscription(row)  }}>{t("btn_cancel")}</button>
                                      </div> */}


                                      <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                        <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                          {can("/admin/subscription/user-subscription-plan/view") && (
                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                              <button type="button" className="btn view" onClick={() => { viewfunction(row); }}>
                                                <i className="ri-eye-fill"></i>
                                              </button>
                                            </Whisper>
                                          )}
                                          {/* {can("/admin/subscription/user-subscription-plan/cancel") && ( */}
                                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Cancel Subscription</Tooltip>}>
                                            <button type="button" className="btn delete" onClick={() => { CancelSubscription(row) }}>
                                              <i className="ri-close-circle-fill"></i>
                                            </button>
                                          </Whisper>
                                          {/* )} */}
                                        </div>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={14} className="text-center">
                                {t("msg_no_records")}
                              </td>
                            </tr>
                          )}
                        </>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className=""
                    id="example1_info"
                    role="status"
                    aria-live="polite"
                  >
                    <b>
                      {t("msg_total_records")} : {datalength ? datalength : "0"}
                    </b>
                  </div>
                  {datalength && datalength > 0 ? (
                    <CustomPagination
                      datalength={datalength}
                      itemperpage={itemperpage}
                      currentPage={page}
                      setPage={setPage}
                      pageRoute={[
                        {
                          name: "",
                          path: "/admin/subscription/user-subscription-plan/list",
                        },
                      ]}
                    />
                  ) : (
                    ""
                  )}
                </>
            }
          </div>
        </div>
      </div>

    </>
  );
};

export default UserSubscriptionTable;
